/* eslint-disable no-console */

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

document.addEventListener("product:variant-change", function (evt) {
  var variant = evt.detail.variant;
  if (!variant) return;
  updatePrice(variant);
});

document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

document.addEventListener("quick-view:loaded", function () {
  console.log("Quick view loaded");
});

/* eslint-enable no-console */

// Varyant dropdown değişimini doğrudan dinle
document.addEventListener("change", function (evt) {
  var select = evt.target.closest("select[name='id']");
  if (!select) return;

  var variantId = select.value;
  fetch("/variants/" + variantId + ".js")
    .then(function (res) { return res.json(); })
    .then(function (variant) {
      updatePrice(variant);
    });
});

function updatePrice(variant) {
  var priceEls = document.querySelectorAll("[data-price]");
  priceEls.forEach(function (el) {
    el.innerHTML = formatMoney(variant.price);
  });

  var comparePriceEls = document.querySelectorAll("[data-compare-price]");
  comparePriceEls.forEach(function (el) {
    if (variant.compare_at_price > variant.price) {
      el.innerHTML = formatMoney(variant.compare_at_price);
    } else {
      el.innerHTML = "";
    }
  });
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString("tr-TR", {
    style: "currency",
    currency: "TRY",
  });
}
